import React from 'react'
import assistedReleaseRemainingTime from '../../util/assistedReleaseRemainingTime'
import Modal from '../Modal'

const AssistedReleaseModal = ({ open, handleClose }) => {
  const tAssist = assistedReleaseRemainingTime()

  return (
    <Modal open={open} noButtons onCancel={handleClose}>
      <div className="flex-1 flex flex-col justify-center items-center">
        <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
          <div className="font-bold text-center my-4 mx-2">Request Assisted Release</div>
          <div className="flex">
            <div className="w-1 bg-primary-light rounded-full">&nbsp;</div>
            <div className="py-1.5 pl-3 text-left">
              <p>
                The estimated time for the boot release is <span className=' whitespace-nowrap'>{tAssist}</span>. We will notify you by SMS when it’s
                completed.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AssistedReleaseModal
